import PropTypes from 'prop-types';
import React from 'react';

import CheckIcon from '../../../../static/icons/ic-check.svg';
import Icon from '../../../components/Icon/Icon';

import './Checkbox.scss';

class Checkbox extends React.Component {
  static propTypes = {
    isChecked: PropTypes.bool,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.bool,
    qaTag: PropTypes.string,
  };

  state = {
    isChecked: this.props.isChecked,
  };

  componentWillReceiveProps(newProps) {
    if (this.props.isChecked !== newProps.isChecked) {
      this.setState({ isChecked: newProps.isChecked });
    }
  }

  onChange = e => {
    const isChecked = e.target.checked;
    this.setState({
      isChecked,
    });

    this.props.onChange({
      value: this.props.value,
      isChecked,
    });
  };

  render() {
    const checkmark = this.state.isChecked ? (
      <Icon className='Checkbox__iconCheckmark' glyph={CheckIcon} />
    ) : (
      ''
    );

    return (
      <div className='Checkbox'>
        <label className='Checkbox__label'>
          {/* eslint-disable-next-line jsx-a11y/no-redundant-roles */}
          <input
            type='checkbox'
            className='Checkbox__label__input'
            name={this.props.name}
            onChange={this.onChange}
            value={this.props.value}
            checked={this.state.isChecked}
            role='checkbox'
            data-qa={this.props.qaTag}
          />
          {checkmark}
        </label>
      </div>
    );
  }
}

export default Checkbox;
